import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

export type SlurryNavigationContext = 'dashboard' | 'standalone';

export const SLURRY_NAVIGATION_CONTEXT_DATA_KEY = 'slurryNavigationContext';

export function resolveSlurryNavigationContext(route: ActivatedRoute, embedded = false): SlurryNavigationContext {
  if (embedded) {
    return 'dashboard';
  }

  return resolveSlurryNavigationContextFromSnapshot(route.snapshot);
}

export function buildSlurryDetailsCommands(
  context: SlurryNavigationContext,
  slurryId: number
): Array<string | number> {
  return context === 'dashboard'
    ? ['/projects-dashboard', 'slurry-details', slurryId]
    : ['/slurry-details', slurryId];
}

export function buildSlurryBatchDetailsCommands(
  context: SlurryNavigationContext,
  slurryId: number,
  batchId: number
): Array<string | number> {
  return [...buildSlurryDetailsCommands(context, slurryId), 'batches', batchId];
}

function resolveSlurryNavigationContextFromSnapshot(snapshot: ActivatedRouteSnapshot): SlurryNavigationContext {
  for (const current of [...snapshot.pathFromRoot].reverse()) {
    const context = current.data?.[SLURRY_NAVIGATION_CONTEXT_DATA_KEY];
    if (context === 'dashboard' || context === 'standalone') {
      return context;
    }
  }

  return 'standalone';
}
